import { render } from "./RadiationCalibration.vue?vue&type=template&id=f2c625b0&scoped=true"
import script from "./RadiationCalibration.vue?vue&type=script&lang=js"
export * from "./RadiationCalibration.vue?vue&type=script&lang=js"

import "./RadiationCalibration.vue?vue&type=style&index=0&id=f2c625b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2c625b0"]])

export default __exports__